/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconTimer/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconTimer({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconTimer",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconTimer.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-n7jgx': alignSelf,'--mt-2-n7jgx': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-n7jgx': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-n7jgx': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-n7jgx': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-n7jgx': opacity,'--w-10-n7jgx': typeof width === 'number' ? `${width}px` : width,'--h-11-n7jgx': typeof height === 'number' ? `${height}px` : height,'--a-7-n7jgx': isAnimated ? animation : "none",'--sd-8-n7jgx': isAnimated ? strokeDashoffset : 0,'--sd-9-n7jgx': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconTimer.SvgPath"
  data-view-path={viewPath}
 d="M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42A8.962 8.962 0 0012 4a9 9 0 00-9 9c0 4.97 4.02 9 9 9a8.994 8.994 0 007.03-14.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
 style={{'--f-12-n7jgx': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}